import { defineMessages } from 'react-intl';

export const ControllerMessages = defineMessages({
  connectControllerButtonLabel: {
    defaultMessage: 'Connect Controller',
    id: 'ScanController.connectController',
  },
  connectControllerTitle: {
    defaultMessage: 'Connect Controller',
    id: 'ScanController.connectControllerTitle',
  },
  changeControllerTitle: {
    defaultMessage: 'Change Controller',
    id: 'ScanController.changeControllerTitle',
  },
  connectControllerActionFailed: {
    id: 'ScanController.connectActionFailed',
    defaultMessage: 'Failed to connect to the controller',
  },
  controllerNotFound: {
    defaultMessage: 'No Controllers Found',
    id: 'ScanController.controllerNotFound',
    description: 'no controllers found message',
  },
  controllerDirections: {
    defaultMessage: 'Bluetooth must be enabled and your controller must be on.',
    id: 'ScanController.controllerDirections',
    description: 'bluetooth connection directions',
  },
  scan: {
    defaultMessage: 'Scan',
    id: 'ScanController.scan',
  },
  scanning: {
    defaultMessage: 'Scanning...',
    id: 'ScanController.scanning',
  },
  scanAgain: {
    defaultMessage: 'Scan again',
    id: 'ScanController.scanAgain',
  },
  scanComplete: {
    defaultMessage: 'Scan complete',
    id: 'ScanController.scanComplete',
  },
  noControllersMatchSearch: {
    defaultMessage: 'Sorry, no Controllers match your search.',
    id: 'Controller.noControllersMatchSearch',
    description: 'Message provided when no controllers match a search criteria',
  },
  controllersHeader: {
    defaultMessage: 'Controllers',
    id: 'Controller.controllersHeader',
  },
  controllerCardIdLabel: {
    id: 'ControllerCard.idLabel',
    defaultMessage: 'ID',
    description: 'Abbreviation for identifier',
  },
  controllerCardFirmwareLabel: {
    id: 'ControllerCard.firmwareLabel',
    defaultMessage: 'Firmware',
    description: 'Label for the firmware version of a controller.',
  },
  controllerGridSoftwareSerialColumn: {
    id: 'ControllerGrid.softwareSerialColumn',
    defaultMessage: 'Software Serial',
    description: 'Column header for the unique software identifier of controllers',
  },
  controller: {
    id: 'Controller.controller',
    defaultMessage: 'Controller',
  },
  controllerGridFirmwareVersionColumn: {
    id: 'ControllerGrid.firmwareVersionColumn',
    defaultMessage: 'Firmware Version',
    description: 'Column header for the firmware version of controllers',
  },
  controllerNameNotProvided: {
    id: 'Controller.nameNotProvided',
    defaultMessage: 'Ctrl Name Not Provided',
    description: 'Abbreviation for Controller name not provided',
  },
  controllerDescriptionNotProvided: {
    id: 'Controller.descriptionNotProvided',
    defaultMessage: 'Ctrl description not provided',
  },
  controllerConnectedLabel: {
    id: 'Controller.connectedLabel',
    defaultMessage: 'Connected',
  },
  controllerConnectLabel: {
    id: 'Controller.connectLabel',
    defaultMessage: 'Connect',
  },
  firmwareVersionLabel: {
    id: 'Controller.firmwareVersionLabel',
    defaultMessage: 'Firmware Version',
  },
  firmwareVersionBeta: {
    id: 'Controller.firmwareVersionBeta',
    defaultMessage: 'Beta',
    description: 'Describes a beta or test version of firmware',
  },
  firmwareVersionCustom: {
    id: 'Controller.firmwareVersionCustom',
    defaultMessage: 'Custom',
    description: 'Describes a custom built firmware version',
  },
  firmwareVersionFieldTest: {
    id: 'Controller.firmwareVersionFieldTest',
    defaultMessage: 'Field Test',
    description: 'Describes a firmware in the field testing phase',
  },
  firmwareVersionDev: {
    id: 'Controller.firmwareVersionDev',
    defaultMessage: 'Dev',
    description: 'Describes a firmware version in the development phase',
  },
  firmwareVersionGlobal: {
    id: 'Controller.firmwareVersionGlobal',
    defaultMessage: 'Global',
    description: 'Describes a firmware version available globally',
  },
  organization: {
    id: 'Controller.organization',
    defaultMessage: 'Organization',
  },
  filter: {
    id: 'Controller.filter',
    defaultMessage: 'Filter',
  },
  filterControllers: {
    id: 'Controller.filterControllers',
    defaultMessage: 'Filter controllers',
  },
  controllerIdLabel: {
    id: 'Controller.controllerIdLabel',
    defaultMessage: 'Controller {physicalId}',
    description: '"{physicalId}" is a variable that is passed in, do not translate.',
  },
  controllerIdentificationLabel: {
    id: 'Controller.controllerIdentificationLabel',
    defaultMessage: 'Controller Id',
  },
  connectedControllerCardDescription: {
    id: 'Controller.connectedControllerCardDescription',
    defaultMessage: 'You are currently connected to Controller {physicalId}. Scan to discover other controllers.',
    description: '"{physicalId}" is a variable that is passed in, do not translate.',
  },
  version: {
    id: 'Controller.version',
    defaultMessage: 'Version',
  },
  firmware: {
    id: 'Controller.firmware',
    defaultMessage: 'Firmware',
  },
  controllerNumber: {
    id: 'Controller.controllerNumber',
    defaultMessage: 'Controller {physicalSerial}',
  },
  updateFirmware: {
    id: 'ControllerDetails.updateFirmware',
    defaultMessage: 'Update Firmware',
  },
  changeController: {
    id: 'ControllerDetails.changeController',
    defaultMessage: 'Change',
  },
  updateFailure: {
    id: 'ControllerDetails.updateFailure',
    defaultMessage: 'Failed to perform update.',
  },
  organizationLabel: {
    id: 'ControllerDetails.organizationLabel',
    defaultMessage: 'Organization',
  },
  organizationPlaceholder: {
    id: 'ControllerForm.organizationPlaceholder',
    defaultMessage: 'Select an organization',
  },
  organizationRequiredError: {
    id: 'ControllerForm.organizationRequiredError',
    defaultMessage: 'Organization is required.',
  },
  softwareSerialId: {
    id: 'ControllerDetails.softwareSerialId',
    defaultMessage: 'Software Serial Id',
  },
  controllerInfo: {
    id: 'ControllerDetails.controllerInfo',
    defaultMessage: 'Controller Information',
  },
  editDescription: {
    id: 'ControllerDetails.editDescription',
    defaultMessage: 'Edit Description',
  },
  connected: {
    id: 'ControllerDetails.connected',
    defaultMessage: 'Connected',
  },
  currentFirmwareVersion: {
    id: 'ControllerDetails.currentFirmwareVersion',
    defaultMessage: 'Current Firmware Version',
  },
  selectFirmwareVersion: {
    id: 'ControllerDetails.selectFirmwareVersion',
    defaultMessage: 'Select a Firmware Version',
  },
  connectionLostHeader: {
    id: 'ConnectionLostModal.header',
    defaultMessage: 'Sorry, connection was lost.',
  },
  connectionLostInstructions: {
    id: 'ConnectionLostModal.instructions',
    defaultMessage:
      'Try reconnecting to the controller, or continue working without a connection and upload job logs later.',
  },
  connectionLostButtonRetry: {
    id: 'ConnectionLostModal.buttonRetry',
    defaultMessage: 'Retry Connection',
  },
  firmwareVersionUpdateSuccess: {
    id: 'ConnectionLostModal.firmwareVersionUpdateSuccess',
    defaultMessage: 'Firmware update successful!',
  },
  firmwareInstallFailure: {
    id: 'ConnectionLostModal.firmwareInstallFailure',
    defaultMessage: 'Firmware installation failed',
  },
  firmwareVersionUpdateDetails: {
    id: 'ConnectionLostModal.firmwareVersionUpdateDetails',
    defaultMessage:
      "The controller has been disconnected and is reloading. Enable wireless when it's finished to reconnect ",
  },
  firmwareInstallFailureDetails: {
    id: 'ConnectionLostModal.firmwareVersionUpdateFailureDetails',
    defaultMessage:
      'An error occurred while trying to install the firmware. Please try again, and notify StoneAge Support if the issue persists.',
  },
  firmwareFetchingFailureDetails: {
    id: 'ConnectionLostModal.firmwareFetchingFailureDetails',
    defaultMessage:
      'An error occurred fetching the firmware file. Please try again, and notify StoneAge Support if the issue persists',
  },
  firmwareLicensingFailureDetails: {
    id: 'ConnectionLostModal.firmwareLicensingFailureDetails',
    defaultMessage:
      'You do not have a license available to install this version of firmware. Contact StoneAge to purchase additional licenses.',
  },
  connectionLostButtonCancel: {
    id: 'ConnectionLostModal.buttonCancel',
    defaultMessage: 'Continue Without BLE Connection',
  },
  updateDescription: {
    id: 'ControllerDetails.updateDescription',
    defaultMessage: 'Update Description',
  },
  updateController: {
    id: 'ControllerDetails.updateController',
    defaultMessage: 'Update Controller',
  },
  descriptionLabel: {
    id: 'ControllerForm.descriptionLabel',
    defaultMessage: 'Description',
  },
  reassignControllerHeader: {
    id: 'Controller.reassignControllerHeader',
    defaultMessage: 'Reassign Controller',
  },
  assignedOrganizationLabel: {
    id: 'Controller.assignedOrganizationLabel',
    defaultMessage: 'Assigned Organization',
  },
  confirmControllerReassignmentBody: {
    id: 'Controller.confirmControllerReassignmentBody',
    defaultMessage: 'Are you sure you want to reassign the controller to {organizationName}?',
    description: '"{organizationName}" is a variable that is passed in, do not translate.',
  },
  confirmControllerReassignmentBodyNonStoneAge: {
    id: 'Controller.confirmControllerReassignmentBodyNonStoneAge',
    defaultMessage: 'You will lose access to this controller.',
  },
  reassignButtonLabel: {
    id: 'Controller.reassignButtonLabel',
    defaultMessage: 'REASSIGN',
  },
  reassignmentSuccessful: {
    id: 'Controller.reassignmentSuccessful',
    defaultMessage: 'Controller {physicalSerial} was reassigned to {organization} successfully.',
    description:
      'Success message displayed upon successful reassignment of a controller. {physicalSerial} AND {organization} should NOT be translated.',
  },
  reassignmentUnsuccessful: {
    id: 'Controller.reassignmentUnsuccessful',
    defaultMessage: 'Controller {physicalSerial} was unable to be reassigned. Please try again.',
    description:
      'Error message displayed when reassignment of a controller is unsuccessful. {physicalSerial} should NOT be translated.',
  },
  firmwareVersionPaid: {
    id: 'Controller.firmwareVersionPaid',
    defaultMessage: 'Paid',
    description: 'Describes a paid firmware version',
  },
  updating: {
    id: 'ControllerDetails.updating',
    defaultMessage: 'Updating',
  },
  updatingFirmwareHelpText: {
    id: 'ControllerDetails.updatingFirmwareHelpText',
    defaultMessage:
      ' - Please remain on this screen until installation has completed. Average installation time is one minute.',
  },
  updateAvailable: {
    id: 'Controller.updateAvailable',
    defaultMessage: 'Update Available',
  },
  installedBundlesListHeader: {
    id: 'ControllerDetails.installedBundlesListHeader',
    defaultMessage: 'Installed Bundles',
  },
  createControllerFormTitle: {
    id: 'Controller.createControllerFormTitle',
    defaultMessage: 'Create controller',
  },
  physicalSerialLabel: {
    id: 'Controller.physicalSerialLabel',
    defaultMessage: 'Physical Serial #',
  },
  physicalSerialPlaceholder: {
    id: 'Controller.physicalSerialPlaceholder',
    defaultMessage: 'Add a physical serial #',
  },
  descriptionPlaceholder: {
    id: 'Controller.descriptionPlaceholder',
    defaultMessage: 'Add a description',
  },
  physicalSerialValueValidation: {
    id: 'CreateController.physicalSerialValueValidation',
    defaultMessage:
      'Physical Serial # may only be an integer between 0-9999, and cannot conflict with existing controllers.',
  },
  createControllerFailedHeader: {
    id: 'CreateController.failedHeader',
    defaultMessage: 'Creating Controller Failed',
  },
  createControllerFailedMessage: {
    id: 'CreateController.failedMessage',
    defaultMessage: 'Please ensure the entered serial number is not already in use.',
  },
  latest: {
    id: 'Controller.latest',
    defaultMessage: 'Latest',
  },
  connecting: {
    id: 'Controller.connecting',
    defaultMessage: 'Connecting',
  },
});
